import Cookie from "../utils/Cookie";

export default function saveTokens(accessToken: string, refreshToken: string) {
  Cookie.setCookie("auth_token", accessToken, true); // store the access token in cookie

  // store the refresh token in local storage
  localStorage.setItem("refresh_token", refreshToken);
}
